import React, { useState, useEffect, useMemo } from 'react';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Collapse from '@mui/material/Collapse';
import { useGlobalStore } from 'store/global/globalStore';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import './Orders.scss';
import { GetFormsByUserID, GetFormsOrder } from 'api/forms.js';
import { useQuery } from '@tanstack/react-query';

function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const userID = useGlobalStore((state) => state.userID);

  const getFormsOrdersQuery = useQuery({
    queryKey: ['getFormsByUserID', userID],
    queryFn: async () => await GetFormsByUserID()(),
    enabled: false,
  });

  const getOrdersList = () => {
    getFormsOrdersQuery.refetch();

    /*const queryParams = {
            crossDomain: true,
            method: 'POST',
            headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }

        fetch('/forms/GetFormsOrders', queryParams)
        .then(res => res.json())
        .then(data => {
            setOrders(JSON.parse(data));
            setLoading(false);
        })*/
  };

  useEffect(() => {
    if (getFormsOrdersQuery.data != null) {
      setOrders(JSON.parse(getFormsOrdersQuery.data));
      setLoading(false);
    }
  }, [getFormsOrdersQuery.data]);

  useEffect(() => {
    getOrdersList();
    return () => setOrders(null);
  }, []);

  return (
    <>
      {loading ? (
        loadingSkeleton()
      ) : (
        <Paper square className="orders-wrapper">
          <TableContainer>
            <Table className="table" stickyHeader aria-label="Orders Table">
              <TableHead>
                <TableRow>
                  <TableCell>Order ID</TableCell>
                  <TableCell>Order Status</TableCell>
                  <TableCell>Order Date</TableCell>
                  <TableCell>Date Completed</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orders.length > 0 ? (
                  orders.map((order) => <OrderTableRow key={order.ID} order={order} />)
                ) : (
                  <TableRow>
                    <TableCell colSpan={4}>You have not made any orders.</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}
    </>
  );

  function loadingSkeleton() {
    return <>loading...</>;
  }
}

function OrderTableRow(props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow onClick={() => (open ? setOpen(false) : setOpen(true))}>
        <TableCell>{props.order.ID}</TableCell>
        <TableCell>{props.order.StatusName}</TableCell>
        <TableCell>{props.order.OrderDate}</TableCell>
        <TableCell>{props.order.DateCompleted}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={4} className="collapsible-cell">
          <Collapse in={open} timeout="auto" unmountOnExit>
            <OrderDetails orderID={props.order.ID} fetchData={open} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

function OrderDetails(props) {
  const [orderDetails, setOrderDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  const getFormsOrderQuery = useQuery({
    queryKey: ['getFormsOrder', props.orderID],
    queryFn: async () => await GetFormsOrder({ ID: props.orderID })(),
    enabled: false,
  });

  const getOrdersList = () => {
    /*const JSONParam = { ID: props.orderID }; 
        const queryParams = {
            crossDomain: true,
            method: 'POST',
            headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(JSONParam)
        }*/

    getFormsOrderQuery.refetch();

    /*fetch('/Forms/GetFormsOrder', queryParams)
        .then(res => res.json())
        .then(data => {
            setOrderDetails(JSON.parse(data));
            setLoading(false);
        })*/
  };

  useEffect(() => {
    if (getFormsOrderQuery.data != null) {
      setOrderDetails(JSON.parse(getFormsOrderQuery.data));
      setLoading(false);
    }
  }, [getFormsOrderQuery.data]);

  useEffect(() => {
    if (props.fetchData === true && orderDetails.length == 0) {
      getOrdersList();
    }
  }, [props.fetchData]);

  return (
    <div className="order-details">
      {loading ? (
        loadingSkeleton()
      ) : (
        <>
          <div className="row">
            <div className="col-12 col-sm-6 general-details order-details-item">
              <h6>
                <b>Delivery Details</b>
              </h6>
              <Divider />
              <span>Address: {orderDetails.Address1}</span>
              <span>Address 2: {orderDetails.Address2}</span>
              <span>City: {orderDetails.City}</span>
              <span>State: {orderDetails.State}</span>
              <span>Zip Code: {orderDetails.Zip}</span>
            </div>
            <div className="col-12 col-sm-6 forms-list order-details-item">
              <h6>
                <b>Forms Ordered</b>
              </h6>
              <Divider />
              <TableContainer>
                <Table
                  className="table"
                  stickyHeader
                  aria-label={'Forms Table for Order ' + orderDetails.ID}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Form Name</TableCell>
                      <TableCell>Form Number</TableCell>
                      <TableCell>Quantity</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orderDetails.Forms.map((form) => (
                      <TableRow key={form.FormNumber}>
                        <TableCell>{form.FormName}</TableCell>
                        <TableCell>{form.FormNumber}</TableCell>
                        <TableCell>{form.Quantity}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </>
      )}
    </div>
  );

  function loadingSkeleton() {
    return <>loading...</>;
  }
}

export { Orders };
